import request from '@/utils/request'
const platform = localStorage.getItem('platform')

export function getMediaMaterials(data) {
    let url = `/${platform}/media_materials`
    return request.get(url, data)
}

export function pullWechatApp(data) {
    const method = 'post'
    const url = `/${platform}/media_materials/pull_wechatapp`
    return request[method](url, data)
}
 
export function previewMaterial(data) {
    const url = `/${platform}/media_materials/${data.id}/get_url`
    return request.get(url)
}

export function changePromotionStatus(ids, $data) {
    ids = ids instanceof Array ? ids.join(',') : ids
    return request.post(`/${platform}/media_materials/change_promotion_status/${ids}`, $data)
}

export function getMediaMaterialsRank(data) {
    let url = `/${platform}/media_materials/rank`
    return request.get(url, data)
}

export function deletePromotion(ids, data) {
    ids = ids instanceof Array ? ids.join(',') : ids
    const url = `/${platform}/media_materials/destroy_promotion/${ids}`
    return request.post(url, data)
}

export function deletePromotionMaterial(ids, data) {
    ids = ids instanceof Array ? ids.join(',') : ids
    const url = `/${platform}/media_materials/destroy_promotion_material/${ids}`
    return request.post(url, data)
}

export function changeAdMaterialStatus(ids, $data) {
    ids = ids instanceof Array ? ids.join(',') : ids
    return request.post(`/${platform}/media_materials/change_promotion_material_status/${ids}`, $data)
}

export function updateMaterialField(data) {
    const url = `/${platform}/media_materials/update_material_field/${data.id}`
    return request.patch(url, data)
}
